import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QCRejectReasonDialogComponent } from './qc-reject-reason-dialog.component';
import { QCRejectReasonDialogConfig } from './model';

@Injectable()
export class QCRejectReasonDialogService {
    constructor(private readonly _dialogService: DialogService) {}

    open(config?: QCRejectReasonDialogConfig): DynamicDialogRef {
        return this._dialogService.open(QCRejectReasonDialogComponent, {
            header: '请输入质检不通过原因',
            width: '80vw',
            modal: true,
            draggable: false,
            resizable: false,
            data: config,
        });
    }
}
